module.exports = __webpack_public_path__ + "img/Picture10.1a4064c4.jpg";